import { useEffect, useState } from "react";
import { useDragger, getPostionCSSClass } from "../../../helper";
import { getCloseButtonStyles } from "../utils/closeButtonStyles";

const LeadCapturedDraggableNudge = ({
  customizeState,
  nudgeId,
  setNudgePosition,
  id,
  setCustomizeState,
}) => {
  // console.log("---> customizeState <---", customizeState);
  const [viewMode, setViewMode] = useState(customizeState?.nudgeShowing?.view_mode || "leadCaptureForm");

  const [userNudge_OfferTextFinal, setUserNudge_OfferTextFinal] = useState("");
  const [formSubmissionNudge_OfferTextFinal, setFormSubmissionNudge_OfferTextFinal] = useState("");
  let left = 0;
  let top = 0;
  if (id === "desktop") {
    left = customizeState?.nudge?.desktopNudgePosition?.left;
    top = customizeState?.nudge?.desktopNudgePosition?.top;
  } else {
    top = customizeState?.nudge?.mobileNudgePosition?.top;
  }

  // useDragger(
  //   `nudgeID${nudgeId + id}`,
  //   left,
  //   top,
  //   setNudgePosition,
  //   id,
  //   setCustomizeState
  // );
  const [nudgePosition, setNudgePostion] = useState("justify-right items-right")


  let hour = "00";
  let minute = "00";
  let timer = `${hour}:${minute}:00 hours`;

  let timeInMinute = customizeState?.nudgeOfferText?.minutes
    ? +customizeState?.nudgeOfferText?.minutes
    : 0;

  if (timeInMinute >= 60) {
    // add 0 before single digit
    hour = timeInMinute / 60;
    hour = hour < 10 ? `0${hour}` : hour;
    minute = timeInMinute % 60;
    minute = minute < 10 ? `0${minute}` : minute;
    timer = `${hour}:${minute}:00 hours`;
  } else {
    timeInMinute = timeInMinute < 10 ? `0${timeInMinute}` : timeInMinute;
    timer = `${timeInMinute}:00 minutes`;
  }
  useEffect(() => {
    let userNudge_offerText = customizeState?.nudgeOfferText?.text;
    let userNudge_ExpiryTime = customizeState?.nudgeOfferText?.minutes;
    setUserNudge_OfferTextFinal(
      userNudge_offerText?.replace("{time}", userNudge_ExpiryTime)
    );
  }, [customizeState?.nudgeOfferText]);

  useEffect(() => {
    let userNudge_offerText = customizeState?.thankYouOfferText?.text;
    let userNudge_ExpiryTime = customizeState?.thankYouOfferText?.minutes;
    setFormSubmissionNudge_OfferTextFinal(
      userNudge_offerText?.replace("{time}", userNudge_ExpiryTime)
    );
  }, [customizeState?.thankYouOfferText]);


  useEffect(() => {
    let nudgePositionVal = customizeState?.nudgePosition?.placement
    // console.log("nudgePositionVal", nudgePositionVal)
    setNudgePostion(nudgePositionVal)
  }, [customizeState?.nudgePosition])
  
  console.log("viewMode", viewMode)
  
  useEffect(() => {
    setViewMode(customizeState?.nudgeShowing?.view_mode)
  }, [customizeState?.nudgeShowing?.view_mode] )
  

  return (
    <div
    className={`h-full flex ${getPostionCSSClass(nudgePosition)}`}
  >
  <div
    id={`nudgeID${nudgeId + id}`}
    className="nudge shadow-md p-3 flex justify-center flex-col gap-3 w-40 text-center select-none"
    style={{
      backgroundColor: `${customizeState?.nudge?.backgroundColor}`,
      borderWidth: `${customizeState?.nudge?.borderWidth}px`,
      borderColor: `${customizeState?.nudge?.borderColor}`,
      borderStyle: `${customizeState?.nudge?.borderStyle}`,
      borderRadius: `${customizeState?.nudge?.borderRadius}px`,
      position: "absolute",
      marginLeft: `${customizeState?.nudgePosition?.margin_left}px`,
      marginTop: `${customizeState?.nudgePosition?.margin_top}px`,
      marginRight: `${customizeState?.nudgePosition?.margin_right}px`,
      marginBottom: `${customizeState?.nudgePosition?.margin_bottom}px`,
      width:"40%"
    }}
      >
        {
          (viewMode === "leadCaptureForm") && (<LeadCaptureNudgeUI customizeState={customizeState} userNudge_OfferTextFinal={userNudge_OfferTextFinal} />)
    //       (<>
    //           <p
    //   className="text-sm text-gray-800 break-words"
    //   style={{
    //     fontStyle: `${customizeState?.nudgeOfferText?.fontStyle}`,
    //     color: `${customizeState?.nudgeOfferText?.textColor}`,
    //     backgroundColor: `${customizeState?.nudgeOfferText?.backgroundColor}`,
    //     borderColor: `${customizeState?.nudgeOfferText?.borderColor}`,
    //     borderStyle: `${customizeState?.nudgeOfferText?.borderStyle}`,
    //     borderRadius: `${customizeState?.nudgeOfferText?.borderRadius}px`,
    //   }}
    // >
    //   <span className="nudgeText">{userNudge_OfferTextFinal}</span>
    // </p>
    // <img
    //   className="max-h-[120px] w-full rounded-lg object-cover"
    //   src={customizeState?.nudgeImages?.image}
    //   alt="nudge hero bannerImage"
    //   style={{
    //     borderWidth: `${customizeState?.nudgeImages?.borderWidth}px`,
    //     borderStyle: `${customizeState?.nudgeImages?.borderStyle}`,
    //     borderColor: `${customizeState?.nudgeImages?.borderColor}`,
    //     borderRadius: `${customizeState?.nudgeImages?.borderRadius}px`,
    //     overflow: "visible",
    //   }}
    // />


    // {/* Input Fields Start */}
    // <div style={{
    //     display:`${customizeState?.nudgeCouponCode?.display}`
    //   }}>
    //     <p
    //       className="text-sm font-semibold px-4 py-1 mb-2 break-words"
    //       style={{
    //         fontStyle: `${customizeState?.nudgeCouponCode?.fontStyle}`,
    //         color: `${customizeState?.nudgeCouponCode?.textColor}`,
    //         backgroundColor: `${customizeState?.nudgeCouponCode?.backgroundColor}`,
    //         borderWidth: `${customizeState?.nudgeCouponCode?.borderWidth}px`,
    //         borderColor: `${customizeState?.nudgeCouponCode?.borderColor}`,
    //         borderStyle: `${customizeState?.nudgeCouponCode?.borderStyle}`,
    //         borderRadius: `${customizeState?.nudgeCouponCode?.borderRadius}px`,
    //         display: `${customizeState?.nudgeInputFields?.inputField1[1]?'block':'none'}`,
    //       }}
    //     >
    //       {`${customizeState?.nudgeInputFields?.inputField1[0]} ${customizeState?.nudgeInputFields?.inputField1[2]?'*':''}`}          </p>
    //     <p
    //       className="text-sm font-semibold px-4 py-1 mb-2 break-words"
    //       style={{
    //         fontStyle: `${customizeState?.nudgeCouponCode?.fontStyle}`,
    //         color: `${customizeState?.nudgeCouponCode?.textColor}`,
    //         backgroundColor: `${customizeState?.nudgeCouponCode?.backgroundColor}`,
    //         borderWidth: `${customizeState?.nudgeCouponCode?.borderWidth}px`,
    //         borderColor: `${customizeState?.nudgeCouponCode?.borderColor}`,
    //         borderStyle: `${customizeState?.nudgeCouponCode?.borderStyle}`,
    //         borderRadius: `${customizeState?.nudgeCouponCode?.borderRadius}px`,
    //         display: `${customizeState?.nudgeInputFields?.inputField2[1]?'block':'none'}`,
    //       }}
    //     >
    //       {`${customizeState?.nudgeInputFields?.inputField2[0]} ${customizeState?.nudgeInputFields?.inputField2[2]?'*':''}`}          </p>
    //     <p
    //       className="text-sm font-semibold px-4 py-1 mb-2 break-words"
    //       style={{
    //         fontStyle: `${customizeState?.nudgeCouponCode?.fontStyle}`,
    //         color: `${customizeState?.nudgeCouponCode?.textColor}`,
    //         backgroundColor: `${customizeState?.nudgeCouponCode?.backgroundColor}`,
    //         borderWidth: `${customizeState?.nudgeCouponCode?.borderWidth}px`,
    //         borderColor: `${customizeState?.nudgeCouponCode?.borderColor}`,
    //         borderStyle: `${customizeState?.nudgeCouponCode?.borderStyle}`,
    //         borderRadius: `${customizeState?.nudgeCouponCode?.borderRadius}px`,
    //         display: `${customizeState?.nudgeInputFields?.inputField3[1]?'block':'none'}`,
    //       }}
    //     >
    //       {`${customizeState?.nudgeInputFields?.inputField3[0]} ${customizeState?.nudgeInputFields?.inputField3[2]?'*':''}`}          </p>
    //     <p
    //       className="text-sm font-semibold px-4 py-1 break-words"
    //       style={{
    //         fontStyle: `${customizeState?.nudgeCouponCode?.fontStyle}`,
    //         color: `${customizeState?.nudgeCouponCode?.textColor}`,
    //         backgroundColor: `${customizeState?.nudgeCouponCode?.backgroundColor}`,
    //         borderWidth: `${customizeState?.nudgeCouponCode?.borderWidth}px`,
    //         borderColor: `${customizeState?.nudgeCouponCode?.borderColor}`,
    //         borderStyle: `${customizeState?.nudgeCouponCode?.borderStyle}`,
    //         borderRadius: `${customizeState?.nudgeCouponCode?.borderRadius}px`,
    //         display: `${customizeState?.nudgeInputFields?.inputField4[1]?'block':'none'}`,
    //       }}
    //     >
    //       {`${customizeState?.nudgeInputFields?.inputField4[0]} ${customizeState?.nudgeInputFields?.inputField4[2]?'*':''}`}
    //     </p>
    //   </div>
    
    // {/* Input Fields End */}

    // <p
    //   className="text-sm px-4 py-1 text-gray-300 break-words cursor-pointer"
    //   style={{
    //     fontStyle: `${customizeState?.nudgeCopyCode?.fontStyle}`,
    //     color: `${customizeState?.nudgeCopyCode?.textColor}`,
    //     backgroundColor: `${customizeState?.nudgeCopyCode?.backgroundColor}`,
    //     borderWidth: `${customizeState?.nudgeCopyCode?.borderWidth}px`,
    //     borderColor: `${customizeState?.nudgeCopyCode?.borderColor}`,
    //     borderStyle: `${customizeState?.nudgeCopyCode?.borderStyle}`,
    //     borderRadius: `${customizeState?.nudgeCopyCode?.borderRadius}px`,
    //   }}
    // >
    //   {customizeState?.nudgeCopyCode?.text}
    //     </p>
    //     <p
    //       className="mt-[-14px]"
    //       style={{
    //         fontStyle: `${customizeState?.nudgeDisclaimerText?.fontStyle}`,
    //         color: `${customizeState?.nudgeDisclaimerText?.textColor}`,
    //         fontSize: `${customizeState?.nudgeDisclaimerText?.fontSize}px`,
    //         display: `${customizeState?.nudgeDisclaimerText?.display}`,
    //       }}
    //     >{customizeState?.nudgeDisclaimerText?.text}</p>
    // <span
    //   className="crossicon absolute top-1 font-bold right-2 cursor-pointer text-xs"
    //   style={{
    //     color: `${customizeState?.nudgeClosed?.textColor}`,
    //     fontSize: `${customizeState?.nudgeClosed?.fontSize}px`,
    //     top: `${customizeState?.nudgeClosed?.topPosition}px`,
    //     right: `${customizeState?.nudgeClosed?.rightPosition}px`,
    //   }}
    // >
    //   X
    //     </span>
        
          
    //       </>)
        }
        {
          (viewMode === "formSubmission") && (<LeadCaptureFormSubmissionUI customizeState={customizeState} formSubmissionNudge_OfferTextFinal={formSubmissionNudge_OfferTextFinal} />)
    //       (<>
          
    //       <p
    //   className="text-sm text-gray-800 break-words"
    //   style={{
    //     fontStyle: `${customizeState?.thankYouOfferText?.fontStyle}`,
    //     color: `${customizeState?.thankYouOfferText?.textColor}`,
    //     backgroundColor: `${customizeState?.thankYouOfferText?.backgroundColor}`,
    //     borderColor: `${customizeState?.thankYouOfferText?.borderColor}`,
    //     borderStyle: `${customizeState?.thankYouOfferText?.borderStyle}`,
    //     borderRadius: `${customizeState?.thankYouOfferText?.borderRadius}px`,
    //   }}
    // >
    //   <span className="nudgeText">{formSubmissionNudge_OfferTextFinal}</span>
    // </p>
    // <img
    //   className="max-h-[120px] w-full rounded-lg object-cover"
    //   src={customizeState?.formSubmissionMedia?.media}
    //   alt="nudge hero bannerImage"
    //   style={{
    //     borderWidth: `${customizeState?.formSubmissionMedia?.borderWidth}px`,
    //     borderStyle: `${customizeState?.formSubmissionMedia?.borderStyle}`,
    //     borderColor: `${customizeState?.formSubmissionMedia?.borderColor}`,
    //     borderRadius: `${customizeState?.formSubmissionMedia?.borderRadius}px`,
    //     display: `${customizeState?.formSubmissionMedia?.display}`,
    //   }}
    // />

    // <p
    //   className="text-sm px-4 py-1 text-gray-300 break-words cursor-pointer"
    //   style={{
    //     fontStyle: `${customizeState?.thankYouButton?.fontStyle}`,
    //     color: `${customizeState?.thankYouButton?.textColor}`,
    //     backgroundColor: `${customizeState?.thankYouButton?.backgroundColor}`,
    //     borderWidth: `${customizeState?.thankYouButton?.borderWidth}px`,
    //     borderColor: `${customizeState?.thankYouButton?.borderColor}`,
    //     borderStyle: `${customizeState?.thankYouButton?.borderStyle}`,
    //     borderRadius: `${customizeState?.thankYouButton?.borderRadius}px`,
    //   }}
    // >
    //   {customizeState?.nudgeCopyCode?.text}
    //     </p>
    //     <p
    //       className="mt-[-14px]"
    //       style={{
    //         fontStyle: `${customizeState?.nudgeDisclaimerText?.fontStyle}`,
    //         color: `${customizeState?.nudgeDisclaimerText?.textColor}`,
    //         fontSize: `${customizeState?.nudgeDisclaimerText?.fontSize}px`,
    //         display: `${customizeState?.nudgeDisclaimerText?.display}`,
    //       }}
    //     >{customizeState?.nudgeDisclaimerText?.text}</p>
    // <span
    //   className="crossicon absolute top-1 font-bold right-2 cursor-pointer text-xs"
    //   style={{
    //     color: `${customizeState?.nudgeClosed?.textColor}`,
    //     fontSize: `${customizeState?.nudgeClosed?.fontSize}px`,
    //     top: `${customizeState?.nudgeClosed?.topPosition}px`,
    //     right: `${customizeState?.nudgeClosed?.rightPosition}px`,
    //   }}
    // >
    //   X
    //     </span>
        
    //       </>)
        }

      </div>
      </div>
  );
};

export default LeadCapturedDraggableNudge;


const LeadCaptureNudgeUI = ({customizeState, userNudge_OfferTextFinal}) => {
  return (<>
  
  <p
      className="text-sm text-gray-800 break-words"
      style={{
        fontStyle: `${customizeState?.nudgeOfferText?.fontStyle}`,
        color: `${customizeState?.nudgeOfferText?.textColor}`,
        backgroundColor: `${customizeState?.nudgeOfferText?.backgroundColor}`,
        borderColor: `${customizeState?.nudgeOfferText?.borderColor}`,
        borderStyle: `${customizeState?.nudgeOfferText?.borderStyle}`,
        borderRadius: `${customizeState?.nudgeOfferText?.borderRadius}px`,
      }}
    >
      <span className="nudgeText">{userNudge_OfferTextFinal}</span>
    </p>
    <img
      className="max-h-[120px] w-full rounded-lg object-cover"
      src={customizeState?.nudgeImages?.image}
      alt="nudge hero bannerImage"
      style={{
        borderWidth: `${customizeState?.nudgeImages?.borderWidth}px`,
        borderStyle: `${customizeState?.nudgeImages?.borderStyle}`,
        borderColor: `${customizeState?.nudgeImages?.borderColor}`,
        borderRadius: `${customizeState?.nudgeImages?.borderRadius}px`,
        display: `${customizeState?.nudgeImages?.display}`,
      }}
    />


    {/* Input Fields Start */}
    <div style={{
        display:`${customizeState?.nudgeCouponCode?.display}`
      }}>
        <p
          className="text-sm font-semibold px-4 py-1 mb-2 break-words"
          style={{
            fontStyle: `${customizeState?.nudgeCouponCode?.fontStyle}`,
            color: `${customizeState?.nudgeCouponCode?.textColor}`,
            backgroundColor: `${customizeState?.nudgeCouponCode?.backgroundColor}`,
            borderWidth: `${customizeState?.nudgeCouponCode?.borderWidth}px`,
            borderColor: `${customizeState?.nudgeCouponCode?.borderColor}`,
            borderStyle: `${customizeState?.nudgeCouponCode?.borderStyle}`,
            borderRadius: `${customizeState?.nudgeCouponCode?.borderRadius}px`,
            display: `${customizeState?.nudgeInputFields?.inputField1[1]?'block':'none'}`,
          }}
        >
          {`${customizeState?.nudgeInputFields?.inputField1[0]} ${customizeState?.nudgeInputFields?.inputField1[2]?'*':''}`}          </p>
        <p
          className="text-sm font-semibold px-4 py-1 mb-2 break-words"
          style={{
            fontStyle: `${customizeState?.nudgeCouponCode?.fontStyle}`,
            color: `${customizeState?.nudgeCouponCode?.textColor}`,
            backgroundColor: `${customizeState?.nudgeCouponCode?.backgroundColor}`,
            borderWidth: `${customizeState?.nudgeCouponCode?.borderWidth}px`,
            borderColor: `${customizeState?.nudgeCouponCode?.borderColor}`,
            borderStyle: `${customizeState?.nudgeCouponCode?.borderStyle}`,
            borderRadius: `${customizeState?.nudgeCouponCode?.borderRadius}px`,
            display: `${customizeState?.nudgeInputFields?.inputField2[1]?'block':'none'}`,
          }}
        >
          {`${customizeState?.nudgeInputFields?.inputField2[0]} ${customizeState?.nudgeInputFields?.inputField2[2]?'*':''}`}          </p>
        <p
          className="text-sm font-semibold px-4 py-1 mb-2 break-words"
          style={{
            fontStyle: `${customizeState?.nudgeCouponCode?.fontStyle}`,
            color: `${customizeState?.nudgeCouponCode?.textColor}`,
            backgroundColor: `${customizeState?.nudgeCouponCode?.backgroundColor}`,
            borderWidth: `${customizeState?.nudgeCouponCode?.borderWidth}px`,
            borderColor: `${customizeState?.nudgeCouponCode?.borderColor}`,
            borderStyle: `${customizeState?.nudgeCouponCode?.borderStyle}`,
            borderRadius: `${customizeState?.nudgeCouponCode?.borderRadius}px`,
            display: `${customizeState?.nudgeInputFields?.inputField3[1]?'block':'none'}`,
          }}
        >
          {`${customizeState?.nudgeInputFields?.inputField3[0]} ${customizeState?.nudgeInputFields?.inputField3[2]?'*':''}`}          </p>
        <p
          className="text-sm font-semibold px-4 py-1 break-words"
          style={{
            fontStyle: `${customizeState?.nudgeCouponCode?.fontStyle}`,
            color: `${customizeState?.nudgeCouponCode?.textColor}`,
            backgroundColor: `${customizeState?.nudgeCouponCode?.backgroundColor}`,
            borderWidth: `${customizeState?.nudgeCouponCode?.borderWidth}px`,
            borderColor: `${customizeState?.nudgeCouponCode?.borderColor}`,
            borderStyle: `${customizeState?.nudgeCouponCode?.borderStyle}`,
            borderRadius: `${customizeState?.nudgeCouponCode?.borderRadius}px`,
            display: `${customizeState?.nudgeInputFields?.inputField4[1]?'block':'none'}`,
          }}
        >
          {`${customizeState?.nudgeInputFields?.inputField4[0]} ${customizeState?.nudgeInputFields?.inputField4[2]?'*':''}`}
        </p>
      </div>
    
    {/* Input Fields End */}

    <p
      className="text-sm px-4 py-1 text-gray-300 break-words cursor-pointer"
      style={{
        fontStyle: `${customizeState?.nudgeCopyCode?.fontStyle}`,
        color: `${customizeState?.nudgeCopyCode?.textColor}`,
        backgroundColor: `${customizeState?.nudgeCopyCode?.backgroundColor}`,
        borderWidth: `${customizeState?.nudgeCopyCode?.borderWidth}px`,
        borderColor: `${customizeState?.nudgeCopyCode?.borderColor}`,
        borderStyle: `${customizeState?.nudgeCopyCode?.borderStyle}`,
        borderRadius: `${customizeState?.nudgeCopyCode?.borderRadius}px`,
      }}
    >
      {customizeState?.nudgeCopyCode?.text}
        </p>
        <p
          className="mt-[-14px]"
          style={{
            fontStyle: `${customizeState?.nudgeDisclaimerText?.fontStyle}`,
            color: `${customizeState?.nudgeDisclaimerText?.textColor}`,
            fontSize: `${customizeState?.nudgeDisclaimerText?.fontSize}px`,
            display: `${customizeState?.nudgeDisclaimerText?.display}`,
          }}
        >{customizeState?.nudgeDisclaimerText?.text}</p>
    <span
      className="crossicon absolute top-1 font-bold right-2 cursor-pointer text-xs"
      style={getCloseButtonStyles(customizeState)}
    >
      X
        </span>
  </>)
}

const LeadCaptureFormSubmissionUI = ({customizeState, formSubmissionNudge_OfferTextFinal}) => {
  return (
    <>
          
          <p
      className="text-sm text-gray-800 break-words"
      style={{
        fontStyle: `${customizeState?.thankYouOfferText?.fontStyle}`,
        color: `${customizeState?.thankYouOfferText?.textColor}`,
        backgroundColor: `${customizeState?.thankYouOfferText?.backgroundColor}`,
        borderColor: `${customizeState?.thankYouOfferText?.borderColor}`,
        borderStyle: `${customizeState?.thankYouOfferText?.borderStyle}`,
        borderRadius: `${customizeState?.thankYouOfferText?.borderRadius}px`,
      }}
    >
      <span className="nudgeText">{formSubmissionNudge_OfferTextFinal}</span>
    </p>
    <img
      className="max-h-[120px] w-full rounded-lg object-cover"
      src={customizeState?.formSubmissionMedia?.media}
      alt="nudge hero bannerImage"
      style={{
        borderWidth: `${customizeState?.formSubmissionMedia?.borderWidth}px`,
        borderStyle: `${customizeState?.formSubmissionMedia?.borderStyle}`,
        borderColor: `${customizeState?.formSubmissionMedia?.borderColor}`,
        borderRadius: `${customizeState?.formSubmissionMedia?.borderRadius}px`,
        display: `${customizeState?.formSubmissionMedia?.display}`,
      }}
    />

    <p
      className="text-sm px-4 py-1 text-gray-300 break-words cursor-pointer"
      style={{
        fontStyle: `${customizeState?.thankYouButton?.fontStyle}`,
        color: `${customizeState?.thankYouButton?.textColor}`,
        backgroundColor: `${customizeState?.thankYouButton?.backgroundColor}`,
        borderWidth: `${customizeState?.thankYouButton?.borderWidth}px`,
        borderColor: `${customizeState?.thankYouButton?.borderColor}`,
        borderStyle: `${customizeState?.thankYouButton?.borderStyle}`,
        borderRadius: `${customizeState?.thankYouButton?.borderRadius}px`,
      }}
    >
      {customizeState?.thankYouButton?.text}
        </p>
        <p
          className="mt-[-14px]"
          style={{
            fontStyle: `${customizeState?.nudgeDisclaimerText?.fontStyle}`,
            color: `${customizeState?.nudgeDisclaimerText?.textColor}`,
            fontSize: `${customizeState?.nudgeDisclaimerText?.fontSize}px`,
            display: `${customizeState?.nudgeDisclaimerText?.display}`,
          }}
        >{customizeState?.nudgeDisclaimerText?.text}</p>
    <span
      className="crossicon absolute top-1 font-bold right-2 cursor-pointer text-xs"
      style={getCloseButtonStyles(customizeState)}
    >
      X
        </span>
    </>
  )
}